import { message } from "antd";
import {
    PENDING_COMMUNICATION_BEGIN,
    PENDING_COMMUNICATION_SUCCESS,
    PENDING_COMMUNICATION_FAILURE,
    CLEAR_PENDING_COMMUNICATION,

    FINISHED_COMMUNICATION_BEGIN,
    FINISHED_COMMUNICATION_SUCCESS,
    FINISHED_COMMUNICATION_FAILURE,
    CLEAR_FINISHED_COMMUNICATION,

    COMUNICATION_PROGRAM_BY_ID_BEGIN,
    COMUNICATION_PROGRAM_BY_ID_SUCCESS,
    COMUNICATION_PROGRAM_BY_ID_FAILURE,
    CLEAR_COMUNICATION_PROGRAM_BY_ID,

    COMUNICATION_PROGRAM_SUMMARY_BEGIN,
    COMUNICATION_PROGRAM_SUMMARY_SUCCESS,
    COMUNICATION_PROGRAM_SUMMARY_FAILURE,
    CLEAR_COMUNICATION_PROGRAM_SUMMARY,

    SPECIALITY_SUMMARY_BEGIN,
    SPECIALITY_SUMMARY_SUCCESS,
    SPECIALITY_SUMMARY_FAILURE,
    CLEAR_SPECIALITY_SUMMARY,

    SYSTEM_SUMMARY_BEGIN,
    SYSTEM_SUMMARY_SUCCESS,
    SYSTEM_SUMMARY_FAILURE,
    CLEAR_SYSTEM_SUMMARY,

    COMPLIANCE_ADVANCE_BEGIN,
    COMPLIANCE_ADVANCE_SUCCESS,
    COMPLIANCE_ADVANCE_FAILURE,
    CLEAR_COMPLIANCE_ADVANCE,
    CLEAR_ALL,

    END_COMMUNICATION_BEGIN,
    END_COMMUNICATION_SUCCESS,
    END_COMMUNICATION_FAILURE,
    QUALIFICATION_PROCESS,

    INSUPD_SEND_EMAIL_REQUEST,
    INSUPD_SEND_EMAIL_SUCCESS,
    INSUPD_SEND_EMAIL_FAIL
} from 'app/actions/CommunicationActions';

const initialState = {
    allIds: [],
    finishedData: [],
    communicationByEmployee: [],
    summary: [],
    specialitySummary: [],
    systemSummary: [],
    complianceAdvance: [],
    complianceAdvanceData: {},
    isLoading: false,
    endCommunication: false
};

export default function WorkReducer(state = initialState, action) {

    switch (action.type) {
        case PENDING_COMMUNICATION_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case PENDING_COMMUNICATION_SUCCESS:
            let _allIds = action.payload.data.Data
            return {
                ...state,
                allIds: _allIds !== null ? _allIds : [],
                isLoading: false,
            };
        case PENDING_COMMUNICATION_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_PENDING_COMMUNICATION:
            return {
                ...state,
                allIds: [],
                isLoading: false
            }
        case FINISHED_COMMUNICATION_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case FINISHED_COMMUNICATION_SUCCESS:
            let finishedData = action.payload.data.Data;
            return {
                ...state,
                finishedData,
                isLoading: false,
            };
        case FINISHED_COMMUNICATION_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_FINISHED_COMMUNICATION:
            return {
                ...state,
                finishedData: [],
                isLoading: false
            }
        case COMUNICATION_PROGRAM_BY_ID_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMUNICATION_PROGRAM_BY_ID_SUCCESS:
            let communicationByEmployee = action.payload.data.Data
            return {
                ...state,
                communicationByEmployee,
                isLoading: false,
            };
        case COMUNICATION_PROGRAM_BY_ID_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_COMUNICATION_PROGRAM_BY_ID:
            return {
                ...state,
                communicationByEmployee: [],
                isLoading: false
            }
        case COMUNICATION_PROGRAM_SUMMARY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMUNICATION_PROGRAM_SUMMARY_SUCCESS:
            let summary = action.payload.data;
            return {
                ...state,
                summary,
                isLoading: false,
            };
        case COMUNICATION_PROGRAM_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_COMUNICATION_PROGRAM_SUMMARY:
            return {
                ...state,
                summary: [],
                isLoading: false
            }
        case SPECIALITY_SUMMARY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case SPECIALITY_SUMMARY_SUCCESS:
            let specialitySummary = action.payload.data;
            return {
                ...state,
                specialitySummary,
                isLoading: false,
            };
        case SPECIALITY_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_SPECIALITY_SUMMARY:
            return {
                ...state,
                specialitySummary: [],
                isLoading: false
            }
        //sYSTEM
        case SYSTEM_SUMMARY_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case SYSTEM_SUMMARY_SUCCESS:
            let systemSummary = action.payload.data;
            return {
                ...state,
                systemSummary,
                isLoading: false,
            };
        case SYSTEM_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_SYSTEM_SUMMARY:
            return {
                ...state,
                systemSummary: [],
                isLoading: false
            }
        case COMPLIANCE_ADVANCE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMPLIANCE_ADVANCE_SUCCESS:
            let complianceAdvance = action.payload.data.Data;
            let complianceAdvanceData = {
                Pending: action.payload.data.Pending,
                Communicated: action.payload.data.Communicated,
                Finished: action.payload.data.Finished,
                Total: action.payload.data.Total,
            }
            return {
                ...state,
                complianceAdvance,
                complianceAdvanceData,
                isLoading: false,
            };
        case COMPLIANCE_ADVANCE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        case CLEAR_COMPLIANCE_ADVANCE:
            return {
                ...state,
                complianceAdvance: [],
                complianceAdvanceData: {},
                isLoading: false
            }
        case END_COMMUNICATION_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case END_COMMUNICATION_SUCCESS:
            return {
                ...state,
                endCommunication: true,
                isLoading: false,
            };
        case END_COMMUNICATION_FAILURE:
            return {
                ...state,
                isLoading: false
            };

        case QUALIFICATION_PROCESS:
            return {
                ...state,
                isLoading: action.payload
            };
        case CLEAR_ALL:
            return state = initialState;
        case INSUPD_SEND_EMAIL_REQUEST:
            return {
                ...state
            }
        case INSUPD_SEND_EMAIL_SUCCESS:
            message.success(action.payload);
            return {
                ...state
            }
        case INSUPD_SEND_EMAIL_FAIL:
            message.error(action.payload);
            return {
                ...state
            }
        default:
            return state;
    }
};

//PendingCommunication
export const getPendingCommunication = state => {
    return state.allIds
}
export const getIsLoadingPendingCommunication = state => {
    return state.isLoading;
}

//FinishedCommunication
export const getFinishedCommunication = state => {
    return state.finishedData
}
export const getIsLoadingFinishedCommunication = state => {
    return state.isLoading;
}

//CommunicationProgramByEmployeeId
export const getCommunicationProgramByEmployeeId = state => {
    return state.communicationByEmployee
}
export const getIsLoadingCommunicationProgramByEmployeeId = state => {
    return state.isLoading;
}

//CommunicationProgramSummary
export const getCommunicationProgramSummary = state => {
    return state.summary
}
export const getIsLoadingCommunicationProgramSummary = state => {
    return state.isLoading;
}

//CommunicationProgramSummary
export const getSpecialitySummary = state => {
    return state.specialitySummary
}
export const getIsLoadingSpecialitySummary = state => {
    return state.isLoading;
}
//CommunicationProgramSummary

export const getSystemSummary = state => {
    return state.systemSummary
}
export const getIsLoadingSystemSummary = state => {
    return state.isLoading;
}

//CommunicationComplianceAdvance
export const getComplianceAdvance = state => {
    return state.complianceAdvance.map(i => Object.assign(i, { TotalRows: state.TotalRows, data: state.complianceAdvanceData }))
}
export const getIsLoadingComplianceAdvance = state => {
    return state.isLoading;
}

//EndCommunication
export const getEndCommunication = state => {
    return state.endCommunication
}
export const getIsLoadingEndCommunication = state => {
    return state.isLoading;
}

export const getIsLoadingQualificationProcess = state => {
    return state.isLoading;
}